import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { Ages } from '@ilteducation/content-registry-types';
import RealNumberInput from '@/components/RealNumberInput.vue';

type Emits = {
  (e: 'update:modelValue', ages: Ages): void;
};
type Props = {
  ages: Ages;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ChooseAges',
  props: {
    ages: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:modelValue', ages: Ages): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  ages: Ages;
}




const { ages } = props;

const min = ref<number>(ages && ages.min ? +ages.min ?? 0 : 0);
const max = ref<number>(ages && ages.max ? +ages.max ?? 99 : 99);

const rules = {
  range: (value: number) => (value >= 0 && value <= 99) || 'Age should be between 0 and 99',
  min: computed(() => min.value <= max.value || 'Min age should be less than or equal to max age'),
  max: computed(() => max.value >= min.value || 'Max age should be more than or equal to min age'),
};

watch(
  () => props.ages,
  (newVal) => {
    if (newVal) {
      min.value = newVal.min ? +newVal.min : min.value;
      max.value = newVal.max ? +newVal.max : max.value;
    }
  },
);

watch([min, max], () => {
  emits('update:modelValue', { min: min.value, max: max.value });
});

return { __sfc: true,emits, props, ages, min, max, rules, RealNumberInput }
}

})